import { FC } from 'react'
import { Divider, Paper } from '@mui/material'
import { useIntl } from 'react-intl'
import { InsuranceConsentResponse } from 'services/insurance/insurance.hooks'
import PropertyDetails from './PropertyDetails'
import ConsentContent from './ConsentContent'
import ConsentActions from './ConsentActions'

interface InsuranceConsentItemProps {
  consent: InsuranceConsentResponse
}

const InsuranceConsentItem: FC<InsuranceConsentItemProps> = ({ consent }) => {
  const { formatMessage } = useIntl()

  return (
    <Paper variant='outlined' sx={{ p: { xs: 2, md: 3 }, mb: 3, borderRadius: 2 }}>
      <PropertyDetails consent={consent} />
      {!!consent.statement && <Divider sx={{ my: 2 }} />}
      <ConsentContent
        statement={consent.statement}
        ariaLabel={formatMessage({
          id: 'insuranceConsent.statementAriaLabel',
          defaultMessage: 'Treść oświadczenia'
        })}
      />
      <ConsentActions consent={consent} />
    </Paper>
  )
}

export default InsuranceConsentItem
